import { z } from "zod";

import avatarMissingImage from "@/assets/images/placeholders/avatar-missing.png";

const suggestionSchema = z.object({
  account_avatar: z.string().catch(avatarMissingImage),
  account_id: z.string(),
  acct: z.string(),
  display_name: z.string(),
  note: z.string().optional(),
  verified: z.boolean().catch(false),
});

type Suggestion = z.infer<typeof suggestionSchema>;

export { suggestionSchema, type Suggestion };
